<template>
  <div class="friends-card">
    <el-card class="card support-box" shadow="hover">
      <template #header>
        <i class="el-icon-s-promotion el-card-header-icon" />
        <span class="el-card-header-txt">友情链接</span>
      </template>
      <el-empty v-if="isLoading" description="暂时没有任何友链, 你可以联系作者申请友链入驻" :image-size="50" />
      <div v-if="!isLoading" class="friend-link-box">
        <el-space wrap size="large">
          <el-tooltip effect="light" :content="f.friendName" placement="top" :key="f.id" v-for="f in friendLinks">
            <a :href="f.websiteUrl" target="_blank" class="friend-link">
              <el-avatar :src="f.avatarUrl" :size="40.6" />
            </a>
          </el-tooltip>
        </el-space>
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import { useDelay, useGetRequest, useLog } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const state = reactive({
      isLoading: useDelay(100).isLoading,
      friendLinks: [],
    })

    // 调接口, 获取所有友链
    useGetRequest('/api/friend_link')
      .then((res) => {
        AssertGoodResponse(res)
        state.friendLinks = res.data.data.collection
      })
      .finally(() => {
        state.isLoading = false
      })

    return {
      ...toRefs(state),
    }
  },
})
</script>

<style lang="scss" scoped>
.friends-card {
  margin-top: 20px;
  .friend-link-box {
    .friend-link {
      display: inline-block;
      cursor: pointer;
    }
  }
}
</style>